import React, { FC } from 'react';
import ResumeProfileModal from '@components/common/modals/resumeProfileModal';
import TermsModal from '@components/profile/modals/terms';
import LoginModal from '@components/loginModal';
import NHISCareerModal from '@components/profile/modals/nhisCareerModal';

import { ProfileOverlayType } from '@domain/constant/profile/ProfileOverlayType';

export type ProfileModalType = 'MATCHING_TERMS' | 'LOGIN' | 'NHIS' | 'RESUME_PROFILE' | null;

interface IPHSPACCModalProps {
  setOverlayState: (type: ProfileOverlayType) => void;
  afterOverlayState: ProfileOverlayType;
  setAfterOverlayState: (type: ProfileOverlayType) => void;
  modalState: ProfileModalType;
  setModalState: (type: ProfileModalType) => void;
}

const ProfileModal: FC<IPHSPACCModalProps> = ({
  setOverlayState,
  afterOverlayState,
  setAfterOverlayState,
  modalState,
  setModalState,
}) => {
  const isVisible = (modalType: ProfileModalType) => modalType === modalState;

  const onClose = () => {
    setModalState(null);
  };

  const onCloseTerms = () => {
    setModalState(null);
    setAfterOverlayState(null);
  };

  const onConfirmTerms = async () => {
    setOverlayState(afterOverlayState);
    setAfterOverlayState(null);
    setModalState(null);
  };

  return (
    <>
      {/* 약관 영역 */}
      <TermsModal visible={isVisible('MATCHING_TERMS')} onConfirm={onConfirmTerms} onClose={onCloseTerms} />
      <NHISCareerModal visible={isVisible('NHIS')} onClose={onCloseTerms} />
      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={isVisible('LOGIN')}
        onClose={onClose}
      />
      <ResumeProfileModal visible={isVisible('RESUME_PROFILE')} onClose={onClose} />
    </>
  );
};

export default ProfileModal;
